import { useState } from 'react'
import type { Metadatos } from './consultas'
import { camposLegibles } from './formato'

interface Props {
  meta?: Metadatos | null
}

/**
 * Los datos que el asistente fue recogiendo, pintados **de forma generica**.
 *
 * Hay tres esquemas de `meta` (10 campos en clientes, 13 en leads, 21 en
 * Valencia) y creceran. El extractor viejo leia siete campos fijos, tres de los
 * cuales ni existen en leads, y por eso la direccion de todo lead salia "No
 * registrada". Aqui se recorre lo que llegue: el backend ya ha quitado los
 * marcadores de "sin dato", asi que todo lo que aparece es dato real.
 *
 * Plegado por defecto: 21 campos por delante de la conversacion, en un movil,
 * dejarian los mensajes fuera de la pantalla.
 */
export function PanelMetadatos({ meta }: Props) {
  const [abierto, setAbierto] = useState(false)
  const campos = camposLegibles(meta)

  if (campos.length === 0) return null

  return (
    <div className="rounded-lg border border-borde bg-superficie">
      <button
        type="button"
        aria-expanded={abierto}
        onClick={() => setAbierto((valor) => !valor)}
        className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-sm font-medium text-tinta-2 transition-colors hover:bg-elevado"
      >
        <span>Datos recogidos ({campos.length})</span>
        <span aria-hidden="true" className="text-xs text-tinta-apagada">
          {abierto ? 'Ocultar' : 'Ver'}
        </span>
      </button>

      {abierto ? (
        <dl className="grid gap-x-4 gap-y-2 border-t border-borde-suave px-3 py-3 sm:grid-cols-2">
          {campos.map((campo) => (
            <div key={campo.clave} className="min-w-0">
              <dt className="text-xs font-semibold uppercase tracking-wide text-tinta-apagada">
                {campo.etiqueta}
              </dt>
              <dd className="whitespace-pre-line break-words text-sm text-tinta-2">
                {campo.valor}
              </dd>
            </div>
          ))}
        </dl>
      ) : null}
    </div>
  )
}
